<div class="panel subscription-usage-panel">
  <div class="section-header">
    <div>
      <h3>{{ 'METRICS.SUBSCRIPTION_USAGE.TITLE' | translate }}</h3>
      <div class="metric-subtext">{{ periodStart | date: 'd MMM y' : 'UTC' }} – {{ periodEnd | date: 'd MMM y' : 'UTC' }}</div>
    </div>
  </div>

  <div class="usage-figures">
    @if (remainingHours !== null) {
      <div class="usage-headline" [class]="'tone-' + tone">
        {{ usage.usedHours | number: '1.0-0' }}
        <span class="usage-of">{{ 'METRICS.SUBSCRIPTION_USAGE.OF_HOURS' | translate: { allowance: usage.allowanceHours } }}</span>
      </div>
      <div class="usage-bar" [class]="'tone-' + tone">
        <div class="usage-bar-fill" [style.width.%]="barFill"></div>
      </div>
      <div class="usage-footnote">
        @if (remainingHours >= 0) {
          {{
            'METRICS.SUBSCRIPTION_USAGE.REMAINING'
              | translate: { hours: (remainingHours | number: '1.0-0'), percentage: (usage.usedPercentage | number: '1.0-0') }
          }}
        } @else {
          <span class="tone-exceeded">{{
            'METRICS.SUBSCRIPTION_USAGE.EXCEEDED'
              | translate: { hours: (-remainingHours | number: '1.0-0'), percentage: (usage.usedPercentage | number: '1.0-0') }
          }}</span>
        }
      </div>
    } @else {
      <div class="usage-headline tone-normal">
        {{ usage.usedHours | number: '1.0-0' }}
        <span class="usage-of">{{ 'METRICS.SUBSCRIPTION_USAGE.HOURS_NO_ALLOWANCE' | translate }}</span>
      </div>
      <div class="usage-footnote">{{ 'METRICS.SUBSCRIPTION_USAGE.NO_ALLOWANCE_RECORDED' | translate }}</div>
    }
    <div class="usage-footnote">{{ 'METRICS.SUBSCRIPTION_USAGE.MEETING_COUNT' | translate: { count: usage.meetingCount } }}</div>
  </div>

  @if (usage.allowanceHours !== null) {
    <div class="alerts">
      <app-threshold-chips-input
        name="thresholds"
        hintKey="METRICS.SUBSCRIPTION_USAGE.ALERTS_HELP"
        [ngModel]="thresholds"
        [disabled]="isSaving"
        (ngModelChange)="saveThresholds($event)"
      ></app-threshold-chips-input>
    </div>
  }
</div>
